import p from "../Components/NcEllipsisedOption.mjs";
import { N as l } from "./NcSelect-DRVEZt73.mjs";
import c from "@nextcloud/axios";
import { generateRemoteUrl as d } from "@nextcloud/router";
import { r as f, g as h, a as o } from "./_l10n-BZu8wI2q.mjs";
import { n as m } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
/**
 * @copyright Copyright (c) 2019 Julius Härtl <jus@bitgrid.net>
 *
 * @author Julius Härtl <jus@bitgrid.net>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const a = (e) => {
  let t = {};
  if (e.nodeType === 1) {
    if (e.attributes.length > 0) {
      t["@attributes"] = {};
      for (let r = 0; r < e.attributes.length; r++) {
        const s = e.attributes.item(r);
        t["@attributes"][s.nodeName] = s.nodeValue;
      }
    }
  } else
    e.nodeType === 3 && (t = e.nodeValue);
  if (e.hasChildNodes())
    for (let r = 0; r < e.childNodes.length; r++) {
      const s = e.childNodes.item(r), n = s.nodeName;
      if (typeof t[n] > "u")
        t[n] = a(s);
      else {
        if (typeof t[n].push > "u") {
          const i = t[n];
          t[n] = [], t[n].push(i);
        }
        t[n].push(a(s));
      }
    }
  return t;
}, g = (e) => {
  let t = null;
  try {
    t = new DOMParser().parseFromString(e, "text/xml");
  } catch (r) {
    console.error("Failed to parse xml document", r);
  }
  return t;
}, u = (e) => {
  const r = a(g(e))["d:multistatus"]["d:response"], s = [];
  for (const n in r) {
    const i = r[n]["d:propstat"];
    i["d:status"]["#text"] === "HTTP/1.1 200 OK" && s.push({
      id: parseInt(i["d:prop"]["oc:id"]["#text"]),
      displayName: i["d:prop"]["oc:display-name"]["#text"],
      canAssign: i["d:prop"]["oc:can-assign"]["#text"] === "true",
      userAssignable: i["d:prop"]["oc:user-assignable"]["#text"] === "true",
      userVisible: i["d:prop"]["oc:user-visible"]["#text"] === "true"
    });
  }
  return s;
}, b = async function() {
  if (window.NextcloudVueDocs)
    return Promise.resolve(u(window.NextcloudVueDocs.tags));
  const e = await c({
    method: "PROPFIND",
    url: d("dav") + "/systemtags/",
    data: '<?xml version="1.0"?>\n					<d:propfind  xmlns:d="DAV:" xmlns:oc="http://owncloud.org/ns">\n					  <d:prop>\n						<oc:id />\n						<oc:display-name />\n						<oc:user-visible />\n						<oc:user-assignable />\n						<oc:can-assign />\n					  </d:prop>\n					</d:propfind>'
  });
  return u(e.data);
};
f(h);
const y = {
  name: "NcSelectTags",
  components: {
    NcEllipsisedOption: p,
    NcSelect: l
  },
  props: {
    // Add NcSelect prop defaults and populate $props
    ...l.props,
    /**
     * Enable automatic fetching of tags
     *
     * If `false`, available tags must be passed using the `options` prop
     */
    fetchTags: {
      type: Boolean,
      default: !0
    },
    /**
     * Callback to generate the label text
     *
     * @see https://vue-select.org/api/props.html#getoptionlabel
     */
    getOptionLabel: {
      type: Function,
      default: (e) => {
        const { displayName: t, userVisible: r, userAssignable: s } = e;
        return r === !1 ? o("{tag} (invisible)", { tag: t }) : s === !1 ? o("{tag} (restricted)", { tag: t }) : t;
      }
    },
    /**
     * Sets the maximum number of tags to display in the dropdown list
     *
     * Because of compatibility reasons only 5 tag entries are shown by
     * default
     */
    limit: {
      type: Number,
      default: 5
    },
    /**
     * Allow selection of multiple options
     *
     * This prop automatically sets the internal `closeOnSelect` prop to
     * its boolean opposite
     *
     * @see https://vue-select.org/api/props.html#multiple
     */
    multiple: {
      type: Boolean,
      default: !0
    },
    /**
     * Callback to filter available options
     */
    optionsFilter: {
      type: Function,
      default: null
    },
    /**
     * Enable passing of `value` prop and emitted `input` events as-is
     * i.e. for usage with `v-model`
     *
     * If `true`, custom internal `value` and `input` handling is disabled
     */
    passthru: {
      type: Boolean,
      default: !1
    },
    /**
     * Placeholder text
     *
     * @see https://vue-select.org/api/props.html#placeholder
     */
    placeholder: {
      type: String,
      default: o("Select a tag")
    },
    /**
     * Currently selected value
     */
    value: {
      type: [Number, Array, Object],
      default: null
    },
    /**
     * Any available prop
     *
     * @see https://vue-select.org/api/props.html
     */
    // Not an actual prop but needed to show in vue-styleguidist docs
    // eslint-disable-next-line
    " ": {}
  },
  emits: [
    "input",
    /**
     * All events from https://vue-select.org/api/events.html
     */
    // Not an actual event but needed to show in vue-styleguidist docs
    " "
  ],
  data() {
    return {
      search: "",
      availableTags: []
    };
  },
  computed: {
    availableOptions() {
      return this.optionsFilter ? this.tags.filter(this.optionsFilter) : this.tags;
    },
    localValue() {
      return this.tags.length === 0 ? [] : this.multiple ? this.value.filter((e) => e !== "").map((e) => this.tags.find((t) => t.id === e)) : this.tags.find((e) => e.id === this.value);
    },
    propsToForward() {
      const {
        // Props handled by this component
        fetchTags: e,
        optionsFilter: t,
        passthru: r,
        // Props to forward
        ...s
      } = this.$props;
      return s;
    },
    tags() {
      return this.fetchTags ? this.availableTags : this.options;
    }
  },
  async created() {
    if (this.fetchTags)
      try {
        const e = await b();
        this.availableTags = e;
      } catch (e) {
        console.error("Loading systemtags failed", e);
      }
  },
  methods: {
    handleInput(e) {
      this.multiple ? this.$emit("input", e.map((t) => t.id)) : e === null ? this.$emit("input", null) : this.$emit("input", e.id);
    }
  }
};
var N = function() {
  var t = this, r = t._self._c;
  return r("NcSelect", t._g(t._b({ attrs: { options: t.availableOptions, "close-on-select": !t.multiple, value: t.passthru ? t.value : t.localValue }, on: { search: (s) => t.search = s }, scopedSlots: t._u([{ key: "option", fn: function(s) {
    return [r("NcEllipsisedOption", { attrs: { name: t.getOptionLabel(s), search: t.search } })];
  } }, { key: "selected-option", fn: function(s) {
    return [r("NcEllipsisedOption", { attrs: { name: t.getOptionLabel(s), search: t.search } })];
  } }, t._l(t.$scopedSlots, function(s, n) {
    return { key: n, fn: function(i) {
      return [t._t(n, null, null, i)];
    } };
  })], null, !0) }, "NcSelect", t.propsToForward, !1), {
    ...t.$listeners,
    input: t.passthru ? t.$listeners.input : t.handleInput
  }));
}, T = [], _ = /* @__PURE__ */ m(
  y,
  N,
  T,
  !1,
  null,
  null,
  null,
  null
);
const V = _.exports;
export {
  V as N
};
